import { useMutation, useQueryClient } from "@tanstack/react-query"

import type { Status } from "../types"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

type UpdateModuleStatusBody = {
  status: Status
  started_at?: string
  completed_at?: string | null
}

type Data = {
  moduleId: string
  body: UpdateModuleStatusBody
}

export function updateModuleStatus(data: Data) {
  const { moduleId, body } = data

  return api.put(`/training/modules/${moduleId}`, body)
}

export function useUpdateModuleStatus() {
  const queryClient = useQueryClient()

  const updateModuleStatusMutation = useMutation({
    mutationFn: ({ moduleId, data }: { moduleId: string; data: UpdateModuleStatusBody }) =>
      updateModuleStatus({ moduleId, body: data }),
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.trainingModules }),
        queryClient.invalidateQueries({ queryKey: queryKeys.trainingProgress }),
        queryClient.invalidateQueries({ queryKey: queryKeys.config }),
      ]),
  })

  return updateModuleStatusMutation
}
